import React, { useEffect, useState } from "react";
import Footer from "../components/Footer.js";
import Navbar from "../components/Navbar.js";
import { useTranslation } from "react-i18next";
import { getCMSPage } from "../action/user.action.js";
import { getLang } from "../lib/localStorage.js";
import config from "../config/index.js";

// img
import w1 from "../assets/images/w1.svg";
import Navbarinner from "../components/Navbarinner.js";

// Scroll to Top
function ScrollToTopOnMount() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return null;
}

export default function About() {
 let langCode = getLang();
 const [content, setContent] = useState("");
  const { t } = useTranslation()

    // function
    const fetchCmsPage = async () => {
        try {
            const { status, loading, result } = await getCMSPage({
                identifier: "cookie_policiy",
                langCode,
            });
            if (status == "success") {
                // console.log('result', result)
                result.content = result.content.replace(
                    /FRONTEND_URL/g,
                    `${config.front_URL}`
                );
                setContent(result);
                document.title = result.title;
                const el = document.querySelector(
                    "meta[name='metadescription']"
                );
                el.setAttribute("content", result.metadescription);

                const els = document.querySelector("meta[name='keywords']");
                els.setAttribute("content", result.metakeywords);
            }
        } catch (err) {}
    };

    useEffect(() => {
        fetchCmsPage();
    }, []);

    console.log(content, "contentcontent");

  return (
    <div>
      <Navbar />
      <div className="common_page" >
        <div className="container">
        <div
            dangerouslySetInnerHTML={{
              __html: content && content.content,
            }}
          />
        </div>
      </div>
      <Footer />
    </div>
  );
}
